// Polyfills
//import 'whatwg-fetch'; // polyfill fetch (<2017)
//import 'promise-polyfill/src/polyfill'; // polyfill promises for fetch (IE11)
//import 'core-js/stable'; // polyfill promises and ES2015 methods (mainly IE11) https://github.com/zloirock/core-js

// Libraries should be imported in a module using them
//import Vue from 'vue';
//import 'slick-carousel';
//import 'magnific-popup';
import 'select2';

// Custom modules
import "./modules/input-detection";
import "./modules/menu";
import { search } from "./modules/search";
import { cookies } from './modules/cookies';
import "./modules/carousel";
import "./modules/loadmore";
import "./modules/latest-articles";
import { render_map } from './modules/map';
//import './modules/googleanalytics'; // track links as events
//import { analytics } from './modules/analytics'; // methods for tracking custom events and pageviews
import components from './components/all';
import './modules/extend-table-public.js';

const $ = window.jQuery;

$(document).ready(function() {
	/* Uncomment import and this, if using acf map block */
    $('.acf-map').each(function(){
        render_map( $(this) );
    });


	$('select').select2({
		minimumResultsForSearch: Infinity
	});

	let navHeight = 0;

	if ($('.helper-nav-container').length > 0) {
		navHeight = navHeight + document.querySelector(".helper-nav-container").offsetHeight;
	}

	if ($('.site-header').length > 0) {
		navHeight = navHeight + document.querySelector(".site-header").offsetHeight;
	}

	navHeight = navHeight + 'px';

	$(":root").css({"--navHeight": navHeight});

    // Kielilippujen korvaaminen SVG-ikonilla
    const globeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M12.3105 22C17.8334 22 22.3105 17.5228 22.3105 12C22.3105 6.47715 17.8334 2 12.3105 2C6.7877 2 2.31055 6.47715 2.31055 12C2.31055 17.5228 6.7877 22 12.3105 22Z" stroke="#1F2933" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.81055 12.5L8.31055 14.5L7.31055 18L8.31055 21" stroke="#1F2933" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.3105 20.5L16.8105 18L14.3105 17V13.5L17.3105 12.5L21.8105 13" stroke="#1F2933" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.3105 5.5L18.8105 7L15.3105 7.5V10.5L17.8105 9.5H19.8105L21.8105 10.5" stroke="#1F2933" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.81055 10.5L5.31055 8.5L7.81055 8L9.81055 5L8.81055 3" stroke="#1F2933" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    // Alusta Select2 kielivalitsimelle
    $('.custom-lang-switcher select').select2({
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true,
        templateSelection: function() {
            return $(globeIcon);
        },
        templateResult: function(state) {
            return $('<span>' + state.text + '</span>');
        }
    });

    // Piilota Select2 nuoli
    $('.custom-lang-switcher .select2-selection__arrow').hide();

    // Kielenvaihtotoiminnallisuus
    $('.custom-lang-switcher select').on('change', function() {
        const url = $(this).val();
        if (url) {
            window.location.href = url;
        }
    });
});